import React, {useContext} from 'react'
import RolesDataHead from "./RolesDataHead"
import RolesDataBody from "./RolesDataBody"
import {Spin} from "antd"
import {SettingRoleContext} from "../../context/SettingRoleContext";

function RolesDataTable() {
    const SettingRolePageContext = useContext(SettingRoleContext)
    const {listRolesData, loadingData} = SettingRolePageContext

    return <div className="LeadTable">
        <Spin spinning={loadingData} tip="Đang lấy dữ liệu...">
            <table className="table">
                <RolesDataHead/>
                <RolesDataBody loading={loadingData} listRoles={listRolesData}/>
            </table>
        </Spin>
    </div>
}

export default RolesDataTable
